export const randomExportSizes = [5, 10, 15, 80, 100];

export const defaultRandomExportSize = randomExportSizes[0];

export const randomExportSizeOptions = randomExportSizes.map(size => ({
  value: size,
  label: size + ' questions'
}));
